import {Component, Inject, Input, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {environment} from '../../../environments/environment';
import {ConfService} from '../../conf.service';
import {DescriptionEditorComponent} from '../../description-editor/description-editor.component';
import {AuthedApiService} from "../../authed-api.service";

declare let Blockly;

@Component({
  selector: 'app-manage-accelerator',
  templateUrl: './manage-accelerator.component.html',
  styleUrls: ['./manage-accelerator.component.scss']
})
export class ManageAcceleratorComponent implements OnInit {

  @Input() isEdit = false;

  @Input() partner: any;
  @Input() account: any;

  steps = [
    {
      progress: 'done',
      completed: true,
      editable: true,
      icon: 'description',
      label: 'Accelerator Info',
      name: 'info',
    },
    {
      progress: 'done',
      completed: true,
      editable: true,
      icon: 'code_blocks',
      label: 'Logic',
      name: 'logic'
    },
    {
      progress: 'done',
      completed: true,
      editable: true,
      icon: 'variables',
      label: 'Logic variables',
      name: 'local_variables'
    },
    {
      progress: 'done',
      completed: true,
      editable: true,
      icon: 'settings_input_component',
      label: 'Connector variables',
      name: 'connector_variables'
    },
    {
      progress: 'done',
      completed: true,
      editable: true,
      icon: 'lan',
      label: 'Dependencies',
      name: 'dependencies'
    },
  ];

  dataTypes = [
      {name: 'String', type: 'text'},
      {name: 'Authorization', type: 'ap_authModel'}
  ];

  serviceProviders: any;

  progressLoading = false;

  acceleratorData: any;
  integrationData: any;
  isIndividualAccelerator = false;
  currentWorkspaceBlocks: any;
  currentWorkspaceAttributeList: any;
  selectIndex = 0;

  initialConnectorVariables: any;
  initialLocalVariables: any;

  isWorkspaceBlocksSwitched = false;

  selectedServiceProviders = [];

  blocksVisible = true;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<ManageAcceleratorComponent>,
              public platform: LeftpanelComponent,
              public dialog: MatDialog,
              private apiService: AuthedApiService,
              private confSrv: ConfService) {

    if (data && data.accelerator && (data.integration || data.isIndividualAccelerator)) {
      this.acceleratorData = data.accelerator;
      this.integrationData = data.integration;
      this.isIndividualAccelerator = data.isIndividualAccelerator ? true : false;
      if (this.isIndividualAccelerator) {
        this.integrationData = {connector_variables: []};
        this.steps = [
          {
            progress: 'done',
            completed: true,
            editable: true,
            icon: 'description',
            label: 'Accelerator Info',
            name: 'info',
          },
          {
            progress: 'done',
            completed: true,
            editable: true,
            icon: 'code_blocks',
            label: 'Logic',
            name: 'logic'
          },
          {
            progress: 'done',
            completed: true,
            editable: true,
            icon: 'lan',
            label: 'Dependencies',
            name: 'dependencies'
          },
        ];
      }
      if (this.acceleratorData && this.acceleratorData.accelerator_source && this.acceleratorData.accelerator_source.accelerator_variables && this.acceleratorData.accelerator_source.source && ((this.integrationData && this.integrationData.connector_variables) || this.isIndividualAccelerator)) {
        this.initialLocalVariables = JSON.parse(JSON.stringify(this.acceleratorData.accelerator_source.accelerator_variables));
        this.initialConnectorVariables = JSON.parse(JSON.stringify(this.integrationData.connector_variables));
        const updatedVariables = this.updateAndGetVariables(this.acceleratorData.accelerator_source.source, this.acceleratorData.accelerator_source.accelerator_variables, this.initialConnectorVariables);
        this.acceleratorData.accelerator_source.accelerator_variables = updatedVariables.local_variables;
        this.integrationData.connector_variables = updatedVariables.connector_variables;
        this.acceleratorData.dependencies = this.acceleratorData.dependencies ? this.acceleratorData.dependencies : {service_providers: []};
        this.acceleratorData.dependencies.service_providers = this.acceleratorData.dependencies.service_providers ? this.acceleratorData.dependencies.service_providers : [];
        for (const key of Object.keys(this.acceleratorData.dependencies)) {
          if (key !== 'service_providers') {
            delete this.acceleratorData.dependencies['key'];
          }

        }
      }
    }


    if (data && data.currentWorkspace) {
      this.currentWorkspaceBlocks = data.currentWorkspace.source;
      this.currentWorkspaceAttributeList = JSON.parse(JSON.stringify(data.currentWorkspace.attributeList));
    }

    if (data && data.isEdit) {
      this.isEdit = data.isEdit;
    }
  }

  ngOnInit() {
    this.getServicesProviders();
  }

  removeDuplicates(arr: any) {
    return arr.filter((item,
                       index) => arr.indexOf(item) === index);
  }

  getServicesProviders() {
    this.confSrv.postIntegrationsApi(environment.integrationsAPI.b2bserviceproviders.name, environment.integrationsAPI.b2bserviceproviders.version, {
      'significance': 'compose',
      'intent': 'b2btitles',
    }).subscribe(data => {
      this.serviceProviders = data;
    }, error => {
      this.progressLoading = false;
    });
  }

  updateAndGetVariables(blockText, origLocalVariables, origConnectorVariables) {
    const xmlDom = Blockly.Xml.textToDom(blockText);
    const blockNodes = xmlDom.getElementsByTagName('block');
    const localVariables = [];
    const connectorVariables = [];
    for (const node of blockNodes) {
      if (node.getAttribute('type') === 'accelerator_variables') {
        const fieldValue = node.childNodes[0].childNodes[0].nodeValue;
        const index = origLocalVariables.findIndex(value => value['name'] === fieldValue);
        if (index === -1) {
          const secondIndex = this.initialLocalVariables.findIndex(value => value['name'] === fieldValue);
          if (secondIndex === -1) {
            localVariables.push({
              name: fieldValue,
              result_block_type: '',
              description: '',
              masked: false,
              required: false,
              value: ''
            });
          } else {
            localVariables.push(this.initialLocalVariables[secondIndex]);
          }

        } else {
          localVariables.push(origLocalVariables[index]);
        }
      }

      if (node.getAttribute('type') === 'accelerator_connector_variables') {
        const fieldValue = node.childNodes[0].childNodes[0].nodeValue;
        const index = origConnectorVariables.findIndex(value => value['name'] === fieldValue);

        if (index === -1) {
          connectorVariables.push({
            name: fieldValue,
            result_block_type: '',
            description: '',
            masked: false,
            required: false,
            value: ''
          });
        } else {
          connectorVariables.push(origConnectorVariables[index]);
        }
      }
    }
    return {
      local_variables: this.removeDuplicates(localVariables),
      connector_variables: this.removeDuplicates(connectorVariables)
    };
  }

  changeToCurrentWorkspaceBlocks() {
    if (this.currentWorkspaceBlocks !== null) {
      const tempSource = this.acceleratorData.accelerator_source.source;
      this.acceleratorData.accelerator_source.source = this.currentWorkspaceBlocks;
      this.currentWorkspaceBlocks = tempSource;

      const tempAttribute = this.acceleratorData.accelerator_source.block_attributes;
      this.acceleratorData.accelerator_source.block_attributes = this.currentWorkspaceAttributeList;
      this.currentWorkspaceAttributeList = tempAttribute;

      const updatedVariables = this.updateAndGetVariables(this.acceleratorData.accelerator_source.source, this.acceleratorData.accelerator_source.accelerator_variables, this.initialConnectorVariables);
      this.acceleratorData.accelerator_source.accelerator_variables = updatedVariables.local_variables;
      this.integrationData.connector_variables = updatedVariables.connector_variables;

      this.blocksVisible = false;
      setTimeout(() => {
        this.blocksVisible = true;
      }, 100);
    }
    this.isWorkspaceBlocksSwitched = !this.isWorkspaceBlocksSwitched;
  }

  checkIsNotEmpty(str) {
    return str && str.length > 0;
  }

  validateData() {
    return new Promise((resolve, reject) => {
      if (this.acceleratorData && this.integrationData) {
        if (this.checkIsNotEmpty(this.acceleratorData.title)
            && this.checkIsNotEmpty(this.acceleratorData.display_name)
            && this.checkIsNotEmpty(this.acceleratorData.short_description)
            && this.checkIsNotEmpty(this.acceleratorData.category)
            && this.checkIsNotEmpty(this.acceleratorData.executor_name)
            && this.checkIsNotEmpty(this.acceleratorData.executor_version)
        ) {
          if (this.acceleratorData.accelerator_source && this.checkIsNotEmpty(this.acceleratorData.accelerator_source.source)) {
              for (const accelerator_variable of this.acceleratorData.accelerator_source.accelerator_variables) {
                if (!this.checkIsNotEmpty(accelerator_variable.name)
                    || !this.checkIsNotEmpty(accelerator_variable.result_block_type)
                ) {
                  reject('Please select a valid data type for the variables.');
                }
              }

              for (const connector_variable of this.integrationData.connector_variables) {
                if (!this.checkIsNotEmpty(connector_variable.name)
                    || !this.checkIsNotEmpty(connector_variable.result_block_type)
                ) {
                  reject('Please select a valid data type for the connector variables.');
                }
              }

              const payload = {
                significance: this.isEdit ? 'refurbish' : 'generate',
                intent: 'accelerator',
                accelerator: this.acceleratorData,
                accelerator_integration_title: this.integrationData.title,
                accelerator_connector_variables: this.integrationData.connector_variables,
              };
              resolve(payload);
          } else {
            reject('Please add a logic.');
          }
        } else {
          reject('Please fill all the required fields in Accelerator Information.');
        }
      }
    });
  }

  upsertIndividualAccelerator() {
    Promise.resolve(this.validateData().then((payload: any) => {
      payload = payload.accelerator
      this.progressLoading = true;
      this.apiService.upsertIndividualAccelerators(payload).subscribe(data => {
        this.progressLoading = false;
        this.platform.openSnackBar('Accelerator ' + (this.isEdit ? 'updated' : 'created') + ' successfully', 'Success', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        this.dialogRef.close(true);
      }, error => {
        this.progressLoading = false;
        this.platform.handleErrorGracefully(error, 'Error while creating/updating.');
      });
    }, error => {
      this.platform.openSnackBar(error, 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }));
  }

  upsertData() {
    Promise.resolve(this.validateData().then(payload => {

      this.progressLoading = true;
      this.confSrv.postIntegrationsApi(environment.integrationsAPI.accelerator.name, environment.integrationsAPI.accelerator.version, payload).subscribe(data => {
        this.progressLoading = false;
        this.platform.openSnackBar('Accelerator ' + (this.isEdit ? 'updated' : 'created') + ' successfully', 'Success', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        this.dialogRef.close(true);
      }, error => {
        this.progressLoading = false;
        this.platform.handleErrorGracefully(error, 'Error while creating/updating.');
      });
    }, error => {
      this.platform.openSnackBar(error, 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }));
  }

  editDescription() {
    const dialogRef = this.dialog.open(DescriptionEditorComponent, {
      height: 'auto',
      width: '90%',
      data: {
        descriptions: this.acceleratorData.description
      }
    });

    dialogRef.afterClosed().subscribe(resp => {
      if (resp) {
        this.acceleratorData.description = resp;
      }
    });
  }

  tabChanged(event) {
    this.selectIndex = event.selectedIndex;
  }

}



@Component({
  selector: 'app-manage-accelerators',
  templateUrl: './manage-accelerators.component.html',
  styleUrls: ['./manage-accelerator.component.scss']
})
export class ManageAcceleratorsComponent implements OnInit {

  @Input() isEdit = false;
  progressLoading = false;

  @Input() selectedAcceleratorIntegration: any;
  @Input() type = 'integration_selector';
  @Input() acceleratorIntegrations: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<ManageAcceleratorsComponent>,
              public platform: LeftpanelComponent,
              private confSrv: ConfService) {
    if (data && data.integrationsData) {
      this.acceleratorIntegrations = data.integrationsData;
    }

    if (data && data.type) {
      this.type = data.type;
    }
  }

  ngOnInit() {
  }

  returnSelectedData() {
    if (this.selectedAcceleratorIntegration && this.selectedAcceleratorIntegration !== '') {
      this.dialogRef.close(this.acceleratorIntegrations[this.acceleratorIntegrations.findIndex(value => value['title'] === this.selectedAcceleratorIntegration)]);
    } else {
      this.platform.openSnackBar('Please select a valid integration', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }
}
